export default __webpack_public_path__ + "src/shared/svg/providers/ceed7ccc4b1b92075f37b859b6fabef6.png";